export const HEADER_FILTER_PERMISSIONS_KEY = 'precifield.headerFilterPermissions';

export type HeaderFilterPermissions = {
  organisation: boolean;
  accounts: boolean;
};

const DEFAULT_HEADER_FILTER_PERMISSIONS: HeaderFilterPermissions = {
  organisation: false,
  accounts: false,
};

export function setHeaderFilterPermissions(
  permissions: HeaderFilterPermissions,
): void {
  localStorage.setItem(
    HEADER_FILTER_PERMISSIONS_KEY,
    JSON.stringify(permissions),
  );
}

export function getHeaderFilterPermissions(): HeaderFilterPermissions {
  const raw = localStorage.getItem(HEADER_FILTER_PERMISSIONS_KEY);

  if (!raw) {
    return DEFAULT_HEADER_FILTER_PERMISSIONS;
  }

  try {
    return JSON.parse(raw) as HeaderFilterPermissions;
  } catch {
    return DEFAULT_HEADER_FILTER_PERMISSIONS;
  }
}

export function clearHeaderFilterPermissions(): void {
  localStorage.removeItem(HEADER_FILTER_PERMISSIONS_KEY);
}
